import { render, staticRenderFns } from "./servizi.vue?vue&type=template&id=77348362"
import script from "./servizi.vue?vue&type=script&lang=js"
export * from "./servizi.vue?vue&type=script&lang=js"
import style0 from "./servizi.vue?vue&type=style&index=0&id=77348362&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports